module.exports = __webpack_public_path__ + "media/Nightcrawler - Metropolis - 10 Genesis (Feat. Dana Jean Phoenix).a1d86e64.mp3";